import { ICopyable } from '../core/copyable.interface';
import { IIdentifiable } from '../core/identifiable.interface';
import { Folder } from './folder';
import { FolderDocument } from './folder-document';
import { History } from './history';
import { IArchivedFolder } from './interface/archived-folder.interface';

/**
 * Represente un dossier
 */
export class ArchivedFolder extends Folder implements ICopyable<ArchivedFolder>, IArchivedFolder, IIdentifiable {
    /**
     * Liste des entrées de l'historique.
     */
    histories: History[];

    /**
     * Liste des documents.
     */
    documents: FolderDocument[];

    public override createCopy(): ArchivedFolder {
        const instance = new ArchivedFolder();
        super.copyFrom(this);

        return instance;
    }

    public override copyFrom(other: any) {
        super.copyFrom(other);
        this.histories = History.fromArray(other.histories);
        this.documents = FolderDocument.fromArray(other.documents);
    }

    /**
     * Retourne un tableau d'instances de Folder à partir d'un tableau d'instances de IFolder.
     * @param other : Tableau d'instances de IFolder.
     * @returns : Tableau d'instances de Folder.
     */
    public static override fromArray(others: IArchivedFolder[]) {
        if (!!others) {
            let folders: Folder[] = [];

            others.forEach((x) => {
                const folder = Folder.from(x);
                folders.push(folder);
            });

            return folders;
        } else {
            return null;
        }
    }

    /**
     * Retourne une instance de Folder à partir d'une instance de IFolder.
     * @param other : Instance de IFolder.
     * @returns : Instance de Folder.
     */
    public static override from(other: IArchivedFolder) {
        if (!!other) {
            const instance = new ArchivedFolder();

            instance.copyFrom(other);

            return instance;
        } else {
            return null;
        }
    }
}
